/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { axiosInstance } from '../axiosInstance'
export const getOktaAllUsers = param => {
    try {
        return axiosInstance.post(`/api/gcadmin/v1/okta/getUsers`, param).then(res => res.data);
    } catch (error) {
        throw error;
    }
}
export const createOktaUser = param => {
    try {
        return axiosInstance.post(`/api/gcadmin/v1/okta/createUser`, param).then(res => res.data);
    } catch (error) {
        throw error;
    }
}
export const deleteOktaUser = param => {
    try {
        return axiosInstance.post(`/api/gcadmin/v1/okta/deleteUser`, param).then(res => res.data);
    } catch (error) {
        throw error;
    }
}